var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 16.8H15.6M15.6 16.8H34.8M15.6 16.8V33.6C15.6 34.2365 15.8528 34.847 16.3029 35.2971C16.753 35.7471 17.3634 36 18 36H30C30.6365 36 31.2469 35.7471 31.697 35.2971C32.1471 34.847 32.4 34.2365 32.4 33.6V16.8M19.2 16.8V14.4C19.2 13.7635 19.4528 13.153 19.9029 12.7029C20.353 12.2529 20.9634 12 21.6 12H26.4C27.0365 12 27.6469 12.2529 28.097 12.7029C28.5471 13.153 28.8 13.7635 28.8 14.4V16.8M21.6 22.8V30M26.4 22.8V30",
    stroke: "#D34558",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.397d14c43afe5df3e12cefa97fac3de8.svg";
export { ForwardRef as ReactComponent };